var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}],on:{"input":_vm.onChange},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('template',{slot:"label"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }